import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  iframe: () => css`
    display: block;
    height: calc(100vh - 113px);
    width: 100vw;
  `,
})

export { useStyles }
